<template>
    <TheModal class="sm" @close="close">
        <template slot="head">
            {{ $route.meta.title }}
            <a target="_blank" :href="getKBLink('add_product')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                <input v-model="form.name" v-focus type="text" class="form-control" maxlength="60" placeholder="Введите название">
            </ValidationProvider>

            <ValidationProvider v-if="hasCrt" v-errors.api vid="vat" tag="div" class="form-group" rules="required">
                <select-vat v-model="form.vat" type="text" class="form-control" />
            </ValidationProvider>

            <ValidationProvider v-if="hasGtin" v-errors.api vid="gtin" tag="div" class="form-group" :rules="{ regex: /^0{0,6}[1-9][0-9]{7,13}$/ }">
                <input v-model="form.gtin" type="text" class="form-control" maxlength="14" placeholder="GTIN">
            </ValidationProvider>

            <div class="mt-4 mb-2">
                <div class="lead mb-2">Себестоимость</div>

                <p class="text-muted small">Укажите стоимость упаковки и её объем.<br>Цена за 1 {{ 1 | unit }} будет рассчитана автоматически.</p>
            </div>

            <template>
                <div class="d-flex align-items-center my-3">
                    <div class="input-group">
                        <input v-model="netPrice" type="number" step="any" class="form-control" min="0" placeholder="Цена" @input="calcNetPrice">
                        <div class="input-group-append">
                            <span id="basic-addon2" class="input-group-text">{{ currency | currencySymbol }}</span>
                        </div>
                    </div>

                    <div class="mx-3">ЗА</div>

                    <div class="input-group">
                        <input v-model="netPriceVolume" type="number" class="form-control" min="0" placeholder="Объем, кол-во" @input="calcNetPrice">
                        <div class="input-group-append">
                            <span id="basic-addon2" class="input-group-text">{{ 1 | unit }}</span>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="form.net_price === null">
                <div>&nbsp;</div>
            </template>

            <template v-else>
                <div>{{ form.net_price }} {{ currency | currencySymbol }} за 1 {{ 1 | unit }}</div>
            </template>

            <div class="mt-4">
                <button type="submit" class="btn btn-primary btn-lg">{{ form.id ? 'Сохранить' : 'Создать' }}</button>
            </div>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import store from '@/store'
import SelectVat from '@/components/SelectVat'
import TheModal from '@/components/TheModal'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import { toastSuccess } from '@/dialogs'
import cloneDeep from 'lodash/cloneDeep'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        SelectVat,
        TheModal,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            form: {
                id: null,
                name: null,
                vat: null,
                gtin: null,
                net_price: null
            },

            netPriceEditMode: true,
            netPrice: '',
            netPriceVolume: 24
        }
    },

    computed: {
        hasCrt() {
            return this.$store.getters['company/hasCrt']
        },

        hasGtin() {
            return this.$store.getters['company/hasGtin']
        },

        currency() {
            return this.$store.state.company.profile.data.currency || null
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'stocks.products' })
        },

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            const done = await this.$store.dispatch('stocks/store', { ...this.form, is_composite: false })

            if (done) {
                this.close()
                toastSuccess(this.form.id ? 'Продукт сохранен' : 'Продукт создан')
            } else {
                mixinApiErrors(this.$refs.obs, this.$store.state.stocks.error)
            }
        },

        calcNetPrice() {
            if (this.netPrice && this.netPrice > 0 && this.netPriceVolume && this.netPriceVolume > 0) {
                const price = this.netPrice / this.netPriceVolume

                this.form.net_price = Math.round(price * 10000) / 10000

                if (this.form.net_price <= 0) {
                    this.form.net_price = null
                }
            } else {
                this.form.net_price = null
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        if (!to.params.id) {
            return next()
        }

        const product = await store.dispatch('stocks/fetchById', parseInt(to.params.id))

        if (product) {
            return next(vm => {
                vm.form = cloneDeep(product)
                vm.form.net_price = vm.form.components[0].net_price
            })
        }

        return next({ name: 'stocks.products' })
    }
}
</script>
